import { useEffect } from "react";
import { useTypedSelector } from "../../../store/reducers/use-typed-selector";

const useShowRecaptchaBadge = (): void => {

	const enableRecaptcha = useTypedSelector(state => !!state.LiveEventReducer.eventBundle?.registration_settings?.enableRecaptcha);

	useEffect(() => {
		const badges = document.querySelectorAll('.grecaptcha-badge');

		if (enableRecaptcha) {
			for (let i = 0; i < badges.length; i++) {
				const badge = badges[i] as any;
				if (badge?.style) {
					badge.style.visibility = 'visible';
				}
			}
		}

		return () => {
			for (let i = 0; i < badges.length; i++) {
				const badge = badges[i] as any;
				if (badge?.style) {
					badge.style.visibility = 'hidden';
				}
			}
		};
	}, [enableRecaptcha]);
};

export default useShowRecaptchaBadge;
